import { Image, ImageProps } from "@chakra-ui/react";
import white from "./images/white.svg";
import blue from "./images/blue.svg";

const colors = {
  white,
  blue,
};

interface LoaderProps extends Omit<ImageProps, "color" | "src" | "alt"> {
  size?: number;
  color?: keyof typeof colors;
}

export const Loader = ({ size = 60, color = "blue", ...props }: LoaderProps) => (
  <Image
    src={colors[color]}
    alt="Loading..."
    style={{ width: size, height: size }}
    {...props}
  />
);
